import { makeStyles } from "@mui/styles";
import tinycolor from "tinycolor2";

export default makeStyles(theme => ({
  // --| actve styling theme in use
  subjectdivide: {
    display: "flex",
    gap: "1.5rem",
    [theme.breakpoints.only("xs")]: {
      flexWrap: "wrap",
      gap: "0.2rem"
    }
  },
  notfound: {
    maxWidth: "300px",
    paddingTop: "15%",
    margin: "auto"
  },
  container: {
    display: "flex",
    // gridTemplateColumns: "repeat(6, 1fr)",
    gap: "2rem 1.5rem",
    padding: "1.5rem",
    "@media (max-width: 517px)": {
      flexWrap: "wrap",
      // gridTemplateColumns: "repeat(3, 1fr)",
      gap: "1rem 0.5rem",
      padding: "1rem 0rem"
    }
  },
  threecontainer: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "2rem 1.5rem",
    padding: "1rem",
    "@media (max-width: 517px)": {
      gap: "1rem 0.5rem",
      padding: "1rem 0rem"
    }
  },

  item: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    cursor: "pointer"
  },

  iconWrapper: {
    width: "35px",
    height: "35px",
    borderRadius: "0.5rem",
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: "#eff6ff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },

  iconStyle: {
    color: theme.palette.primary.main,
    width: "22px",
    height: "22px"
  },

  actionitem: {
    color: theme.palette.primary.main,
    cursor: "pointer"
  },

  label: {
    marginTop: "0.5rem",
    fontSize: "0.875rem",
    fontWeight: 600,
    color: theme.palette.primary.main,
    textAlign: "center"
  },
  hosteldetail: {
    marginBlock: "0px",
    "& h2": {
      fontWeight: "800",
      fontSize: "24px",
      color: "#344054",
      marginBlock: "0px",
      textAlign: "left"
    },
    "& p": {
      fontWeight: "400",
      fontSize: "14px",
      color: theme.palette.primary.main,
      marginBlock: "0px 5px",
      textAlign: "left"
    }
  },
  wrapper: {
    display: "flex",
    height: "calc(100vh - 300px)",
    background: "#fff",
    border: "1px solid #E4E7EC",
    borderRadius: "16px",
    padding: "1rem",
    marginTop: "16px"
  },

  // Sidebar
  sidebar: {
    background: "#f7f8fa",
    padding: "1rem",
    display: "flex",
    flexDirection: "column",
    borderRight: "1px solid #e0e0e0",
    height: "calc(100vh - 330px)",
    transition: "all 0.3s ease",
    overflowY: "auto",
    flexShrink: 0
  },
  sidebarOpen: {
    width: "320px",
    minWidth: "320px"
  },
  sidebarCollapsed: {
    width: "60px",
    minWidth: "60px"
  },

  navTop: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "1rem",
    color: "#444",
    fontWeight: 500
  },

  backIcon: {
    fontSize: "20px"
  },

  tabNav: {
    display: "flex",
    gap: "1rem",
    backgroundColor: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.07).toRgbString(),
    padding: "0.6rem",
    borderRadius: "6px",
    width: "100%",
    justifyContent: "space-between",
    marginBottom: "1rem",
    "& p": {
      fontSize: "0.9rem",
      fontWeight: 600,
      color: theme.palette.primary.main,
      marginBlock: "0px"
    }
  },

  tab: {
    flex: 1,
    padding: "0.5rem 1.25rem",
    fontSize: "0.9rem",
    fontWeight: 500,
    color: "#6b7280",
    background: "transparent",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#e5e7eb"
    }
  },
  activeTab: {
    flex: 1,
    padding: "0.5rem 1.25rem",
    fontSize: "0.9rem",
    fontWeight: 600,
    color: "#111827",
    backgroundColor: "#ffffff",
    border: "1px solid #d1d5db",
    borderRadius: "10px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    cursor: "pointer"
  },

  inactiveTab: {
    flex: 1,
    padding: "0.6rem",
    border: "none",
    background: "#eee",
    fontWeight: 600,
    cursor: "pointer",
    color: "#666"
  },

  chatList: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem"
  },

  chatTile: {
    textAlign: "left",
    display: "flex",
    justifyContent: "space-between",
    padding: "0.75rem",
    borderRadius: "10px",
    background: "#fff",
    cursor: "pointer",
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
    "& p": {
      marginBlock: "4px"
    }
  },

  chatTileActive: {
    background: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.07).toRgbString(),
    display: "flex",
    justifyContent: "space-between",
    textAlign: "left",
    padding: "0.75rem",
    cursor: "pointer",
    borderRadius: "6px"
  },
  chatTiles: {
    background: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.07).toRgbString(),
    display: "flex",
    justifyContent: "space-between",
    textAlign: "left",
    padding: "0.75rem",
    border: `1px solid ${theme.palette.primary.main}`,
    cursor: "pointer",
    borderRadius: "6px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"
  },

  chatTitle: {
    fontWeight: 600,
    margin: 0
  },

  chatSub: {
    fontSize: "0.85rem",
    color: "#666",
    marginTop: "0.25rem"
  },

  chatTime: {
    fontSize: "0.75rem",
    color: "#888"
  },

  sectionLabel: {
    marginTop: "1.2rem",
    fontSize: "0.75rem",
    color: "#666",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontWeight: 600,
    textTransform: "uppercase",
    marginBlock: "0px"
  },

  // Chat Panel
  chatPanel: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 330px)",
    flexGrow: 1,
    minWidth: 0
  },

  chatHeader: {
    padding: "1rem",
    borderBottom: "1px solid #eee",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "& p": {
      marginBlock: "0px"
    }
  },

  chatHeading: {
    fontSize: "1.1rem",
    fontWeight: 600
  },

  memberLink: {
    fontSize: "0.85rem",
    color: "#5b6fff",
    textDecoration: "underline"
  },

  chatBody: {
    flex: 1,
    padding: "1rem",
    background: "#f9f9fb",
    overflow: "hidden"
  },

  chatHeight: {
    width: "100%",
    height: "100%",
    overflowY: "auto",
    boxSizing: "border-box"
  },

  chatInputArea: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "0.5rem 1rem",
    borderTop: "1px solid #ccc",
    backgroundColor: "#fff",
    gap: "0.5rem",
    boxSizing: "border-box"
  },

  chatInput: {
    flex: 1,
    padding: "0.6rem 1rem",
    border: "none",
    // borderRadius: "8px",
    outline: "none",
    fontSize: "1rem",
    backgroundColor: "none"
  },
  addnew: {
    color: theme.palette.primary.main
  },

  sendButton: {
    backgroundColor: theme.palette.primary.main,
    border: "none",
    padding: "0.5rem 0.5rem",
    borderRadius: "50%",
    color: "#fff",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },

  memberBox: {
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 8,
    padding: "0.5rem",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.06)",
    marginBottom: "0.5rem",
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "#fff",
    "&:first-of-type": {
      marginTop: "32px"
    }
  },
  name: {
    fontWeight: 600,
    fontSize: "1rem"
  },
  role: {
    color: theme.palette.primary.main,
    fontSize: "0.9rem"
  },

  emojiPicker: {
    position: "absolute",
    bottom: "60px",
    left: "0",
    zIndex: 100
  },
  noMember: {
    textAlign: "center",
    color: "#888",
    padding: "1rem"
  },

  icon: {
    fontSize: "1.5rem",
    color: theme.palette.primary.main
  },

  input: {
    flex: 1,
    border: "none",
    fontSize: "1rem",
    outline: "none"
  },
  invenhead: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "50%",
    "& p": {
      marginBlock: "0px"
    },
    "& h4": {
      marginBlock: "0px",
      fontWeight: "500",
      fontSize: "20px"
    },
    "@media (max-width: 728px)": {
      width: "100%",
      marginBottom: "6px"
    }
  },
  overview: {
    border: "1px solid #E4E7EC",
    padding: "16px",
    borderRadius: "16px",
    minHeight: "calc(100vh - 300px)"
  },
  fadeContainer: {
    transition: "opacity 0.5s ease, transform 0.5s ease",
    opacity: 1,
    transform: "translateY(0)"
  },
  flexx: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "@media (max-width: 728px)": {
      flexDirection: "column",
      justifyContent: "left",
      alignItems: "flex-start"
    }
  },
  fadeHidden: {
    opacity: 0,
    transform: "translateY(10px)",
    pointerEvents: "none",
    position: "absolute"
  },
  fadeContent: {
    marginTop: "20px",
    opacity: 0,
    animation: "$fadeIn 0.4s ease forwards",
    transform: "translateY(10px)"
  },
  pendingAttachments: {
    position: "absolute",
    top: "-6px",
    right: "-6px",
    background: "#fff",
    borderRadius: "50%",
    color: "#f00",
    fontWeight: "bold",
    cursor: "pointer",
    padding: "0 4px"
  },
  pendingImage: {
    width: "60px",
    height: "60px",
    objectFit: "cover",
    borderRadius: "8px"
  },
  imageFlexing: {
    display: "flex",
    gap: "8px",
    padding: "4px 0",
    flexWrap: "wrap"
  },
  "@keyframes fadeIn": {
    to: {
      opacity: 1,
      transform: "translateY(0)"
    }
  }

}));
